import User from "./User";
import Spinner from "react-bootstrap/Spinner";
import PaginationComponent from "../../../../../component/global/PaginationComponent";
import { useEffect, useState } from "react";
import { get, post } from "../../../../../controlers/global/ConfigRequest";
import {
    COMPANY_CLUBS,
    SHARE_MEMBERS,
} from "../../../../../helperData/ApiAddress";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function BetweenUsers({ content }) {
    const [loading, setLoading] = useState(false);
    const [sendLoading, setSendLoading] = useState(false);
    const [members, setMembers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const { t } = useTranslation();

    const fetchUsers = () => {
        setLoading(true);
        get(COMPANY_CLUBS.replace("{id}/", currentPage))
            .then((r) => {
                setMembers(r.results);
                setPageCount(r.lastPage);
            })
            .finally((e) => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchUsers();
    }, [currentPage]);

    const userListHandle = (id, add) => {
        if (add) {
            setSelectedMembers([...selectedMembers, id]);
        } else {
            setSelectedMembers(selectedMembers.filter((item) => item !== id));
        }
    };

    const shareHandle = () => {
        setSendLoading(true);
        post(SHARE_MEMBERS, {
            content,
            members: selectedMembers,
        }).finally((r) => {
            setSelectedMembers([]);
            setSendLoading(false);
        });
    };

    return (
        <>
            <div className="table">
                <div className="user-grid">
                    {loading === false ? (
                        members.length > 0 ? (
                            members.map((member, index) => (
                                <User
                                    data={member}
                                    selectedMembers={selectedMembers}
                                    setSelectedMembers={setSelectedMembers}
                                    key={index}
                                />
                            ))
                        ) : (
                            <div>
                                {t(
                                    "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.BetweenUsers.NothingFound.Label"
                                )}
                            </div>
                        )
                    ) : (
                        <Spinner animation="border" />
                    )}
                </div>
            </div>
            <div className="pagination">
                <PaginationComponent
                    pageCount={pageCount}
                    key={currentPage}
                    fetchData={(e) => console.log(e)}
                    currentPage={currentPage - 1}
                    setCurrentPage={(e) => setCurrentPage(e + 1)}
                    feedbacks={4}
                />
                <div className="button-box">
                    <Button
                        onClick={shareHandle}
                        className="form_btn medium blue"
                        disabled={selectedMembers.length === 0}
                    >
                        {sendLoading ? (
                            <Spinner animation="border" />
                        ) : (
                            <span>
                                {t(
                                    "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.BetweenUsers.Sharing"
                                )}
                            </span>
                        )}
                    </Button>
                    {/* <Button className="form_btn medium white_border_red">انصراف</Button> */}
                </div>
            </div>
        </>
    );
}
